// extracted by css-extract-rspack-plugin
export default {"cls1":"SortPanel-cls1_ZE4","cls2":"SortPanel-cls2_qy_ SortPanel-cls1_ZE4","active":"SortPanel-active_tB9"};